export default {
  hero_badge: 'Uporządkowane zasoby · Przewodniki · Regularnie aktualizowane',
  hero_title: 'USFans Spreadsheet — znajdź, odkrywaj i porządkuj informacje o twórcach',
  hero_subtitle: 'Poznaj uporządkowany USFans Spreadsheet z zasobami twórców, przydatnymi przewodnikami, porównaniami, recenzjami, informacjami o wysyłce i wskazówkami bezpieczeństwa — wszystko w jednym prostym centrum.',
  hero_primary_cta: 'Poznaj USFans Spreadsheet',
  hero_secondary_cta: 'Przeglądaj zasoby twórców',
  hero_dropdown_label: 'Wybierz kategorię, aby zacząć',
  hero_dropdown_placeholder: 'Wybierz kategorię…',
  btn_spreadsheet: 'usfans spreadsheet',
  btn_buy_now: 'kup teraz',
  categories_title: 'Przeglądaj kategorie produktów',
  categories_subtitle: 'Wybierz kategorię poniżej, aby przejść bezpośrednio do pasujących produktów na stronie głównej. Każdy link otwiera się w nowej karcie, więc możesz tu wrócić w dowolnym momencie.',
  category_shoes: 'Buty',
  category_hoodies: 'Bluzy/Swetry',
  category_tshirts: 'Koszulki',
  category_jackets: 'Kurtki',
  category_pants: 'Spodnie/Szorty',
  category_headwear: 'Nakrycia głowy',
  category_sets: 'Zestawy',
  category_underwear: 'Bielizna/Majtki',
  category_jersey: 'Koszulka sportowa',
  category_accessories: 'Akcesoria',
  category_bags: 'Torby',
  category_belts: 'Paski',
  category_perfumes: 'Perfumy',
  category_other: 'Inne rzeczy',
  about_title: 'Czym jest USFans Spreadsheet?',
  about_p1: 'USFans Spreadsheet to prosty, uporządkowany sposób przeglądania produktów i informacji o twórcach związanych z USFans. Zamiast szukać po rozproszonych stronach jedna po drugiej, wszystko jest pogrupowane w czytelne kategorie — od butów i bluz po torby, paski i perfumy — dzięki czemu szybciej znajdziesz to, czego szukasz.',
  about_p2: 'Naszym celem jest ułatwienie zrozumienia informacji. Zbieramy przydatne przewodniki, porównania i wskazówki bezpieczeństwa w jednym miejscu, a następnie łączymy Cię ze stroną główną, gdzie znajduje się cała gama produktów. Jesteśmy niezależnym zasobem, a nie oficjalną witryną USFans.',
  about_p3: 'Niezależnie od tego, czy odkrywasz po raz pierwszy, czy porównujesz opcje przed zakupem, arkusz daje Ci czysty punkt wyjścia. Użyj przycisków kategorii lub menu rozwijanego, aby przejść bezpośrednio do interesujących Cię produktów.',
  article_section_title: 'Przewodniki, recenzje i porady USFans',
  article_section_subtitle: 'Poznaj naszą bibliotekę szczegółowych artykułów USFans: arkusze, recenzje, wysyłka, oferty, bezpieczeństwo i więcej.',
  article_card_title: 'Czym jest USFans Spreadsheet?',
  article_card_excerpt: 'Kompletny, przyjazny dla początkujących przewodnik o tym, czym jest USFans Spreadsheet, co można w nim znaleźć i jak go używać do bezpiecznego przeglądania produktów i informacji o twórcach.',
  article_read_more: 'Przeczytaj pełny przewodnik',
  cta_title: 'Gotowy, aby poznać całą gamę?',
  cta_text: 'Przeglądaj uporządkowane kategorie i przewodniki tutaj, a następnie odwiedź stronę główną, aby zobaczyć pełny wybór produktów.',
  cta_primary: 'Odwiedź stronę główną',
  cta_secondary: 'Poznaj USFans Spreadsheet',
};